import {LocationQuery, LocationQueryRaw, LocationQueryValueRaw} from "vue-router";

export function shortenText(text: string, maxLength: number): string {
    // Verifica se o texto é maior que o comprimento máximo permitido e adiciona reticências no meio se necessário
    if (text.length <= maxLength) {
        return text;
    }
    const halfLength = Math.floor((maxLength - 3) / 2);
    return text.substring(0, halfLength) + '...' + text.substring(text.length - halfLength);
}

export function shortenFileName(fileName: string, maxLength: number): string {
    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex === -1) {
        return shortenText(fileName, maxLength);
    }

    const namePart = fileName.substring(0, dotIndex);
    const extensionPart = fileName.substring(dotIndex);
    return `${shortenText(namePart, maxLength)}${extensionPart}`;
}

export function firstLetterToUpperCase(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export function serializeForKey<T>(value: T): string {
    if (value === null || value === undefined) return ''

    if (Array.isArray(value)) {
        return `[${value.map(serializeForKey).join(',')}]`
    }

    if (typeof value === 'object') {
        return `{${Object.keys(value)
            .sort()
            .map(key => `${key}:${serializeForKey(value[key])}`)
            .join('|')}}`
    }

    return String(value)
}

type Primitive = string | number | boolean | null | undefined | Date

function normalizeValue(value: Primitive): LocationQueryValueRaw {
    if (value === undefined) return undefined
    if (value === null) return null

    if (value instanceof Date) {
        return value.toISOString()
    }

    if (typeof value === 'boolean') {
        return value ? 'true' : 'false'
    }

    return value
}

function serializeForRoute<T extends Record<string, unknown>>(
    value: T | null | undefined
): LocationQueryRaw | LocationQuery {
    if (!value) return {}

    const query: LocationQueryRaw = {}

    for (const [key, raw] of Object.entries(value)) {
        if (raw === undefined) continue

        if (Array.isArray(raw)) {
            const serializedArray = raw
                .map(item => normalizeValue(item as Primitive))
                .filter(v => v !== undefined)

            if (serializedArray.length > 0) {
                query[key] = serializedArray
            }

            continue
        }

        if (
            typeof raw === 'string' ||
            typeof raw === 'number' ||
            typeof raw === 'boolean' ||
            raw === null ||
            raw instanceof Date
        ) {
            const normalized = normalizeValue(raw)
            if (normalized !== undefined) {
                query[key] = normalized
            }
            continue
        }

        // fallback para objetos complexos
        query[key] = JSON.stringify(raw)
    }

    return query
}

export function serializeForRouteQuery<T extends Record<string, unknown>>(
    value: T | null | undefined
): LocationQuery {
    return serializeForRoute(value) as LocationQuery
}

export function serializeForRouteQueryRaw<T extends Record<string, unknown>>(
    value: T | null | undefined
): LocationQueryRaw {
    return serializeForRoute(value) as LocationQueryRaw
}